// acc 手机号验证规则
const rules = {
    url: '/acc/2/in/rule/mobile/get_rules',
    method: 'get'
};

// 发送验证码
const sendVerificationCode = {
    url: '/acc/2/in/verification_code/send',
    method: 'post',
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
};

export default {
    rules,
    sendVerificationCode
};



// WEBPACK FOOTER //
// ./src/service/common/acc.js